import React from 'react';
import { Drawer, Form, Button, Popconfirm } from 'antd';
import {connect} from 'react-redux'
import {GroupForm} from 'components/partials'
import {groupActions, accountActions} from 'actions'
import _ from 'lodash'

class CreateOrEditGroup extends React.Component {
  constructor(){
    super();
    this.formRef = React.createRef()
    this.state = { 
      visible: false,
      createGendersVisible: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onClose = this.onClose.bind(this)
    this.triggerSubmit = this.triggerSubmit.bind(this)
  }

  get form() {
    return this.formRef.current
  }

  get group(){
    return this.props.group || {}
  }

  triggerSubmit() {
    return this.form.submit()
  }

  async handleSubmit (values) {
    const _group = {
        name: values.name,
        description: values.description
    }
    let group
    if(this.group.id){
      group = await groupActions.update({
          id: this.group.id,
          ..._group
      })
    } else {
      group = await groupActions.create(_group)
      this.props.onSetCurrentGroup && this.props.onSetCurrentGroup(group.id)
    }
    this.form && this.form.resetFields();
    this.props.onClose && this.props.onClose(group)
  }

  onClose(){
    this.form && this.form.resetFields();
    
    this.props.onClose()
  }

  componentDidUpdate(previousProps){
      if(previousProps.visible != this.props.visible){
          this.form && this.form.resetFields();
          this.setState(this.state) // rerender
      }
  }

  render() {    

    let edit = false;
    
    if(this.group.id){
      edit = true
    }

    const initialValues = {
        id: this.group.id,
        name: this.group.name,
        description: this.group.description,
    }
    return (
      <Drawer
        title={this.group.id ? 'Edit Group' : 'Create Group'}
        width={720}
        placement="right"
        onClose={this.props.onClose}
        visible={this.props.visible}
        style={{
          height: 'calc(100% - 55px)',
          overflow: 'auto',
          paddingBottom: 53,
        }}
      >
        <Form ref={this.formRef} initialValues={initialValues} layout="vertical" onFinish={this.handleSubmit}>
            <GroupForm formRef={this.formRef} hideClientSelect={this.props.hideClientSelect} group={this.group} account={this.account}/>
        </Form>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }}
          >
          {edit && 
              <Popconfirm placement="topRight" title='Are you sure' okText="Yes" onConfirm={this.handleDestroyGroup} cancelText="No">
                  <Button type='danger' className='pull-left'>Delete Group</Button>
              </Popconfirm>
          }
          <Button
            style={{
              marginRight: 8,
            }}
            onClick={this.onClose}
            >
            Cancel
          </Button>
          <Button onClick={this.triggerSubmit} type="primary" htmlType="submit">{this.group.id ? 'Update' : 'Create' }</Button>
        </div>
      </Drawer>
    );
  }
}
export default connect((state)=> state)(CreateOrEditGroup)